import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { COLORS } from '../config/colors';
import { strings } from '../strings';
import LocationIcon from './icons/LocationIcon';

type CurrentLocationButtonProps = {
  onPress: () => void;
};

const CurrentLocationButton = ({ onPress }: CurrentLocationButtonProps) => {
  const insets = useSafeAreaInsets();

  return (
    <Pressable
      accessibilityLabel={strings.goToCurrentLocation}
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [
        styles.button,
        // Sit above the bottom SearchBar: 12 (bar inset) + 48 (bar height) + 18 (gap).
        { bottom: insets.bottom + 78 },
        pressed && styles.buttonPressed,
      ]}
    >
      <LocationIcon color={COLORS.ink} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  // Same look as the other floating buttons, differing only in positioning.
  button: {
    position: 'absolute',
    right: 16,
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    backgroundColor: COLORS.surface,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  buttonPressed: {
    opacity: 0.8,
  },
});

export default CurrentLocationButton;